import {Component, Inject, AfterViewInit, OnInit} from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {WebPdfComponent} from '../../../../components/web/web-pdf/web-pdf.component';
import {DateiService} from '../../../../services/prozesse/datei.service';
import {DialogVerwaltungsService} from '../services/dialogVerwaltungs.service';

@Component({
  selector: 'gesetz-dialog',
  templateUrl: './ebKundenInfoDialog.component.html',
  styleUrls: ['./ebKundenInfoDialog.component.css']
})
export class EbKundenInfoDialogComponent implements OnInit, AfterViewInit{

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dateiService: DateiService,
    private dialogService: DialogVerwaltungsService
  ) { }

  ngOnInit() {}

  ngAfterViewInit() {
    const element = document.getElementById('matDialogContent');
    element.scrollIntoView();
  }

  openPDF() {
    if (Object.keys(this.data.data.pdf).length == 1){
      this.direktPDF(this.data.data.pdf)
    } else {
      const dialogRef = this.dialogService.standardDialog(
        'Verfügbare PDF-Speisepläne',
        WebPdfComponent,
        {pdf: this.data.data.pdf, mandant: this.data.data.mandant}
      )
      }
    }

  direktPDF(pdf){
    this.dateiService.speiseplanPDF(Object.values(pdf)[0]).subscribe(file => {
      setTimeout(() => { window.open(URL.createObjectURL(file)) }, 50)
    })
  }
}
